<script setup lang="ts">
type Props = {
  iconsQuantity?: number;
};

const { iconsQuantity = 5 } = defineProps<Props>();

const { payments } = useRuntimeConfig().public;

const cryptosAllowedList = computed(() => {
  return payments.crypto.allowedCryptos.split(',');
});

const cryptosData = ref(cryptosAllowedList.value);
</script>

<template>
  <div :class="$style.paymentLogos">
    <template
      v-for="(option, index) in cryptosData"
      :key="option"
    >
      <NuxtIcon
        v-if="index <= iconsQuantity - 1"
        :class="$style.icon"
        :filled="true"
        :name="`cryptos/${option}`"
      />
    </template>
    <span :class="$style.more"></span>
  </div>
</template>

<style module lang="postcss">
.paymentLogos {
  @apply flex items-center justify-start gap-1;
  .icon {
    @apply w-6 h-6 overflow-hidden;
    svg {
      @apply w-6 h-6;
    }
  }
  .more {
    @apply w-6 h-6 bg-auth-texts/5 text-auth-texts/80 rounded-full text-center flex items-center justify-center font-bold leading-[0.1em];
    &:before {
      @apply content-['...'] relative -top-1;
    }
  }
}
</style>
